export default __webpack_public_path__ + "traffic-signs-header-image-960-7b64d6dcf42966cd989c0150b4a62488.webp";